import React, { Fragment, useMemo, useRef, useState, useEffect } from 'react';
import { useQuery } from 'react-apollo';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Spinner from '../../../../../../../../../components/global/Spinner';
import { getPhotoSearchCheckoutSearchItemsQuery } from '../../../../../../../../temp/views/onboarding/PhotoSearchCheckout/graphql/queries/getPhotoSearchCheckoutSearchItems';
import { FEATURE_SETS, getFeatureSets } from '../../helpers';
import UpgradeSelectionBox from '../UpgradeSelectionBox';
import { sortSubscriptionsByBillingPeriod } from '../../../../../../../../temp/views/onboarding/PhotoSearchUpsell/components/SearchSubscriptionFeatureUpsell/helpers';
import {
  SEARCH_SUBSCRIPTION_PLAN,
  SEARCH_SUBSCRIPTION_PLAN_BILLING_PERIOD,
} from '../../../../../../../../temp/views/onboarding/PhotoSearchCheckout/helpers';

const propTypes = {
  stepProps: PropTypes.shape({
    eventAddonItems: PropTypes.array,
    freeEventCreationEnabled: PropTypes.bool,
    isEveryDayShare: PropTypes.bool,
  }).isRequired,
  setStepProps: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func,
  disableSubmit: PropTypes.bool,
  onSkip: PropTypes.func,
};

const UpgradeSelectionBoxes = ({
  stepProps,
  setStepProps,
  handleSubmit,
  disableSubmit,
  onSkip,
}) => {
  const boxesRef = useRef();
  const [scroll, setScroll] = useState({ x: 0, y: 0 });
  const { data: { searchSubscriptionItems } = {}, loading } = useQuery(
    getPhotoSearchCheckoutSearchItemsQuery,
  );

  const { isEveryDayShare, upgradeSelectionBoxesScroll } = stepProps;

  const onScroll = () => {
    setScroll({
      x: boxesRef?.current?.scrollLeft,
      y: boxesRef?.current?.scrollTop,
    });
  };

  useEffect(() => {
    boxesRef?.current?.addEventListener?.('scroll', onScroll);

    return () => {
      boxesRef?.current?.removeEventListener?.('scroll', onScroll);
    };
  }, [boxesRef]);

  useEffect(() => {
    if (boxesRef?.current && upgradeSelectionBoxesScroll) {
      boxesRef.current.scrollLeft = upgradeSelectionBoxesScroll.x;
      boxesRef.current.scrollTop = upgradeSelectionBoxesScroll.y;
    }
  }, [boxesRef, upgradeSelectionBoxesScroll]);

  if (!searchSubscriptionItems || loading) {
    return (
      <div className="text-center my-4">
        <Spinner data-testid="loading-spinner" />
      </div>
    );
  }

  const sets = useMemo(() => getFeatureSets({ isEveryDayShare }), [
    isEveryDayShare,
  ]);
  const setSearchSubscriptionItems = {
    [FEATURE_SETS.GOLD]: [],
    [FEATURE_SETS.PLUS]: sortSubscriptionsByBillingPeriod(
      searchSubscriptionItems.filter(
        ({ plan }) => plan === SEARCH_SUBSCRIPTION_PLAN.SHUTTERBUG_PLUS,
      ),
      SEARCH_SUBSCRIPTION_PLAN_BILLING_PERIOD.YEARLY,
    ),
  };

  const classes = classNames({
    'subscription-upgrade-selection-boxes': true,
    'subscription-upgrade-selection-boxes-standalone': sets.length === 1,
  });
  return (
    <Fragment>
      <div ref={boxesRef} className={classes}>
        {sets.map(set => (
          <UpgradeSelectionBox
            key={set}
            set={set}
            searchSubscriptionItems={setSearchSubscriptionItems[set]}
            upgradeSelectionBoxesScroll={scroll}
            stepProps={stepProps}
            setStepProps={setStepProps}
            handleSubmit={handleSubmit}
            disableSubmit={disableSubmit}
            onSkip={onSkip}
          />
        ))}
      </div>
    </Fragment>
  );
};

UpgradeSelectionBoxes.propTypes = propTypes;

export default UpgradeSelectionBoxes;
